import {
  RegistrationIcon_default
} from "./chunk-ASZBVWKW.mjs";
export {
  RegistrationIcon_default as default
};
